"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u0032 = void 0;
var u0032 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1925 2436H675v-213l480-522q83-89 194-215t177.5-255.5T1593 950q0-156-87-245t-236-89q-130 0-235 52.5T836 803L696 640q137-122 282.5-178.5T1273 405q264 0 418 145t154 390q0 134-48 256t-132.5 242-298.5 350l-385 410v11h944v227z"
    },
    "children": []
  }]
};
exports.u0032 = u0032;